const API_BASE = process.env.NEXT_PUBLIC_API_URL || '/api/v1';

export class ApiError extends Error {
  status: number;
  key: string;

  constructor(status: number, key: string, message: string) {
    super(message);
    this.status = status;
    this.key = key;
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (res.status === 401) {
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw new ApiError(401, 'unauthorized', 'Unauthorized');
  }

  if (!res.ok) {
    const error = await res.json().catch(() => ({ detail: { key: 'unknown', message: 'API error' } }));
    const detail = error.detail || {};
    throw new ApiError(
      res.status,
      detail.key || 'unknown',
      detail.message || `API error: ${res.status}`
    );
  }

  const json = await res.json();
  // Some endpoints wrap in { success, data, error }, others return raw
  if (json !== null && typeof json === 'object' && 'data' in json && 'success' in json) {
    return json.data as T;
  }
  return json as T;
}
